import React, { useState, useEffect, useRef } from "react";
import { Button, Form } from "react-bootstrap";
import BSPagination from "../../Components/pagination";
import LoadingSpinner from "../../Components/spinner";
import {
  getPaginatedContactUs,
  searchContactUs,
} from "../../services/axios/apiManager";
import { handleErrors } from "../../services/dataManager";
import { useNavigate } from "react-router-dom";
import ContactUsDetailsModal from "./contactUsDetailsModal";
import ContactUsRespondModal from "./respondModal";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";

const ContactUsList = ({
  contactUs,
  setContactUs,
  pagination,
  setPagination,
  categories,
  granted,
}) => {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [category, setCategory] = useState("");
  const [status, setStatus] = useState(2);
  const [filtering, setFiltering] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showRespondModal, setShowRespondModal] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  // const [contactUs, setContactUs] = useState([]);
  // const [pagination, setPagination] = useState({});
  const tableRef = useRef(null);

  // // // Fetch Contact Us list
  const fetchContactUsList = async (pgn, filters = "") => {
    setFiltering(true);
    const res = await getPaginatedContactUs(
      pgn?.currentPage || 1,
      pgn?.pageSize || 10,
      filters
    );
    if (res?.data?.success && res?.data?.data) {
      setContactUs(res.data.data);
      if (res?.data?.pagination) {
        setPagination(res.data.pagination);
      }
    } else {
      handleErrors(res, navigate);
    }
    setFiltering(false);
  };

  // // // Handle Pagination

  // // // Reset all filters to default
  const resetFilters = async () => {
    setStatus(2);
    setQuery("");
    setCategory("");
    await fetchContactUsList(pagination);
  };

  // // // Fetch Contact us list by categories
  const fetchFbByCategory = async (e) => {
    const cat = e.target.value;
    setCategory(cat);
    if (cat.length > 0) {
      setQuery("");
      const filters = `category=${cat}&status=${status}`;
      await fetchContactUsList(pagination, filters);
    } else {
      await fetchContactUsList(pagination);
    }
  };

  // // // Fetch Contact us by Responded or not
  const fetchRecordsByStatus = async (e) => {
    const sts = e.target.value;
    setStatus(sts);
    setQuery("");
    const filters = `category=${category}&status=${sts}`;
    await fetchContactUsList(pagination, filters);
  };

  // // //Search Contact us logic
  const handleSearch = async (e) => {
    const string = e.target.value;
    setStatus(2);
    setCategory("");
    setQuery(string);
    if (string.length > 0) {
      setFiltering(true);
      const res = await searchContactUs(string);
      if (res?.data?.data) {
        setContactUs(res.data.data);
        if (res?.data?.pagination) {
          setPagination(res.data.pagination);
        }
      } else {
        handleErrors(res, navigate, "Search:");
      }
      setFiltering(false);
    } else {
      await fetchContactUsList(pagination);
    }
  };

  const handlePageChange = async (page) => {
    const temp = { ...pagination };
    setPagination((prev) => ({ ...prev, currentPage: page }));
    temp.currentPage = page;
    const filters = `category=${category}&status=${status}`;
    await fetchContactUsList(temp, filters);
  };

  useEffect(() => {
    if (!tableRef.current) return;

    // build row arrays
    const rows = contactUs.map((fb) => [
      fb.category,
      fb.first_name,
      fb.last_name,
      fb.email,

      `<span class="${fb.responded ? "text-success" : "text-danger"}" data-id="${fb.id}" title=${fb.responded ? "Responded" : "Not-responded"}>
        ${fb.responded ? "Yes" : "No"}
      </span>`,
      `
        <button class="btn btn-outline-success btn-sm view-btn" data-id="${fb.id}" title="view details">
          <i class="fas fa-eye"></i>
        </button>
        ${
          fb.responded
            ? `<button class="btn btn-outline-info btn-sm me-1" disabled title="Responded">
                 <i class="fas fa-check"></i>
               </button>`
            : `<button class="btn btn-outline-info btn-sm respond-btn me-1" data-id="${fb.id}" title="respond">
                 <i class="fas fa-reply"></i>
               </button>`
        }
      `,
    ]);

    const config = {
      data: rows,
      columns: [
        { title: "Category" },
        { title: "First Name" },
        { title: "Last Name" },
        { title: "Email Address" },
        { title: "Responded", orderable: false },
        { title: "Action", orderable: false },
      ],
      destroy: true,
      paging: false,
      searching: false,
      info: false,
      responsive: true,
    };

    const $tbl = $(tableRef.current);
    if ($.fn.dataTable.isDataTable($tbl)) {
      $tbl.DataTable().clear().rows.add(rows).draw();
    } else {
      $tbl.DataTable(config);
    }

    // Unbind then bind handlers
    $tbl.off("click", ".view-btn respond-btn");
    $tbl.on("click", ".view-btn", function () {
      const id = $(this).data("id");
      const fb = contactUs.find((c) => c.id === id);
      setSelectedData(fb);
      setShowDetailsModal(true);
    });
    $tbl.on("click", ".respond-btn", function () {
      const id = $(this).data("id");
      const fb = contactUs.find((c) => c.id === id);
      // if (!granted?.some((p) => p.type === "update")) {
      //   toast.error("No permission to respond");
      //   return;
      // }
      setSelectedData(fb);
      setShowRespondModal(true);
    });

    return () => {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $tbl.DataTable().destroy();
      }
    };
  }, [contactUs, granted]);

  return (
    <div className="container py-4 text-light bg-dark rounded mb-4">
      <div className="row align-items-center mb-4">
        <div className="col-md-12 row">
          <div className="col-md-4">
            <Form.Control
              type="text"
              placeholder="Search..."
              value={query}
              onChange={(e) => {
                handleSearch(e);
              }}
              className="bg-dark text-light border-light input-placeholder-light"
            />
          </div>
          <div className="col-md-3">
            <Form.Select
              name="categories"
              value={category}
              onChange={(e) => {
                fetchFbByCategory(e);
              }}
              className="bg-dark border-light text-light"
            >
              <option value="">All Categories</option>
              {categories?.map((c) => (
                <option value={c}>{c}</option>
              ))}
            </Form.Select>
          </div>
          <div className="col-md-3">
            <Form.Select
              name="status"
              value={status}
              onChange={(e) => {
                fetchRecordsByStatus(e);
              }}
              className="bg-dark border-light text-light"
            >
              <option value="2">All Issues</option>
              <option value="1">Responded</option>
              <option value="0">Not Responded</option>
            </Form.Select>
          </div>
          <div className="col-md-2" data-testid="spinner-md">
            {filtering ? (
              <LoadingSpinner size={"md"} />
            ) : (
              <Button
                title="Reset Filters And Rrfresh Records"
                className="btn btn-success"
                onClick={() => {
                  resetFilters();
                }}
              >
                Reset
              </Button>
            )}
          </div>
        </div>
      </div>

      <div className="table-responsive">
        <table
          ref={tableRef}
          className="table table-striped table-hover table-dark w-100"
        />
        <div className="constainer-fluid">
          <div className="d-flex justify-content-end">
            <div className="mx-4 py-2">
              <span className="text-light">{`Rows/Page ${pagination.pageSize || 0}, Total records ${pagination?.totalRecords || 0}`}</span>
            </div>
            <BSPagination
              currentPage={pagination?.currentPage}
              totalPages={pagination?.totalPages}
              onPageChange={handlePageChange}
              siblingCount={2}
              showFirstLast={true}
            />
          </div>
        </div>
        <ContactUsDetailsModal
          showDetailsModal={showDetailsModal}
          setShowDetailsModal={setShowDetailsModal}
          selectedData={selectedData}
          setSelectedData={setSelectedData}
        />
        <ContactUsRespondModal
          showRespondModal={showRespondModal}
          setShowRespondModal={setShowRespondModal}
          selectedData={selectedData}
          setSelectedData={setSelectedData}
          pagination={pagination}
          fetchContactUsList={fetchContactUsList}
        />
      </div>
    </div>
  );
};

export default ContactUsList;
